const reportWebVitals = onPerfNode => {
  if (onPerfNode && onPerfNode instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfNode);
      getFID(onPerfNode);
      getFCP(onPerfNode);
      getLCP(onPerfNode);
      getTTFB(onPerfNode);
    });
  }
};

export default reportWebVitals;
